/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ExchangeCancelCategory } from './exchange-cancel-category';

/**
 * 
 * @export
 * @interface CancelExchangeDataDto
 */
export interface CancelExchangeDataDto {
    /**
     * 환급 uuid
     * @type {string}
     * @memberof CancelExchangeDataDto
     */
    'exchangeUuid': string;
    /**
     * 환급 신청 금액
     * @type {number}
     * @memberof CancelExchangeDataDto
     */
    'amountRequested': number;
    /**
     * 환급 상태
     * @type {string}
     * @memberof CancelExchangeDataDto
     */
    'status': CancelExchangeDataDtoStatusEnum;
    /**
     * 생성 일시
     * @type {string}
     * @memberof CancelExchangeDataDto
     */
    'createdAt': string;
    /**
     * 기타 환급 불가 사유
     * @type {string}
     * @memberof CancelExchangeDataDto
     */
    'exchangeCancelOtherReason': string;
    /**
     * 환급 (예정) 일시
     * @type {string}
     * @memberof CancelExchangeDataDto
     */
    'exchangeAt': string;
    /**
     * 취소 여부
     * @type {boolean}
     * @memberof CancelExchangeDataDto
     */
    'isCancelled': boolean;
    /**
     * 환급 불가 사유
     * @type {ExchangeCancelCategory}
     * @memberof CancelExchangeDataDto
     */
    'exchangeCancelCategory': ExchangeCancelCategory;
}

export const CancelExchangeDataDtoStatusEnum = {
    Application: 'application',
    Waiting: 'waiting',
    Completed: 'completed',
    Impossible: 'impossible'
} as const;

export type CancelExchangeDataDtoStatusEnum = typeof CancelExchangeDataDtoStatusEnum[keyof typeof CancelExchangeDataDtoStatusEnum];


